/**
 * Animate text number value.
 */
AFRAME.registerComponent('text-counter', {
  dependencies: ['text'],

  schema: {
    decimals: {default: 0},
    dur: {default: 2000, type: 'int'},
    enabled: {default: false},
    emit: {default: false},
    prefix: {default: ''},
    suffix: {default: ''},
    value: {default: 0.0, type: 'float'}
  },

  init: function () {
    this.currentValue = 0;
    this.hasCompleted = false;
    this.textValue = {value: ''};
  },

  update: function (oldData) {
    this.currentValue = 0;
    this.textValue.value = `${this.data.prefix}${this.decimals(0)}${this.data.suffix}`;
    this.el.setAttribute('text', this.textValue);
    this.hasCompleted = false;
  },

  tick: function (time, timeDelta) {
    if (!this.data.enabled || this.hasCompleted) { return; }

    this.currentValue += this.data.value * (timeDelta / this.data.dur);

    if (this.currentValue >= this.data.value) {
      this.currentValue = this.data.value;
      if (this.data.emit) { this.el.emit('textcounterdone', null, false); }
      this.hasCompleted = true;
    }

    this.textValue.value =
      `${this.data.prefix}${this.decimals(this.currentValue)}${this.data.suffix}`;
    this.el.setAttribute('text', this.textValue);
  },

  decimals: function (n) {
    var d = Math.pow(10, this.data.decimals);
    return (parseInt(n * d) / d).toFixed(this.data.decimals);
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['text-counter',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
